import { render, staticRenderFns } from "./View2D.vue?vue&type=template&id=0459e6e4&scoped=true&"
import script from "./View2D.vue?vue&type=script&lang=js&"
export * from "./View2D.vue?vue&type=script&lang=js&"
import style0 from "./View2D.vue?vue&type=style&index=0&id=0459e6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459e6e4",
  null
  
)

export default component.exports